const Alert = (props) => {
/**
   * Children adalah props khusus.
   * Berisi konten/children yang ada di dalam component.
   */
return <div>{props.children}</div>
}

export default Alert;